<div *ngIf="!showApprovalMatrix">
  <div class="approval-matrix-header">
    <p>{{'raci.portfolioProperties.approval1' | translate}}</p>
    <p>{{'raci.portfolioProperties.approval2' | translate}}</p>
    <p>{{'raci.portfolioProperties.approval3' | translate}}</p>
  </div>
  <div class="approval-matrix-body">
    <div class="approval">
      <svg-icon src='./assets/icons/icon-by-region-default.svg'
                title="{{'raci.portfolioProperties.participants' | translate | uppercase}}"
                class="menu-action-icon svg-icon-red"
                align='center'>
      </svg-icon>
      <div>
        <input type="checkbox"
               [ngClass]="{'property-approved': isProjectSelectable() == false , 'property-rejected' :  isProjectRejectedCheckbox() }"
               [(ngModel)]="isProjectSelected"
               (click)="selectAllProperties()" />
      </div>
      <h3 class="approval-project-name">{{projectName}}</h3>
      <kendo-grid *ngIf="projectApproval?.length > 0 && !groupBy"
                  [data]="projectApproval"
                  #projectApprovalsGrid
                  class="kendo-white-grid approval-grid"
                  (cellClick)="onApprovalSelection($event, true)"
                  (drop)="onDrop($event, true)"
                  (dragover)="onDragOver($event, raciParticipantsGrid)"
                  [hideHeader]="true">
        <kendo-grid-column [headerClass]="'participants-grid'"
                           field="project"
                           title="{{'raci.portfolioProperties.titleProject' | translate}}"
                           class="fill-line"
                           [width]="auto"></kendo-grid-column>
        <kendo-grid-column [headerClass]="'participants-grid fill-line'"
                           field="line"
                           title="{{'raci.portfolioProperties.titleLine' | translate}}"
                           [width]="auto"></kendo-grid-column>
        <kendo-grid-column [headerClass]="'participants-grid fixed-properties-column-width'"
                           field="approvalUser1"
                           title=""
                           [width]="170">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="approved-date"
                  *ngIf="dataItem.dateApproved1">
              {{ dataItem.dateApproved1 | date: 'dd.MM.YYYY' }}
            </span>
            <span class="approved-date"
                  *ngIf="dataItem.dateRejected1 && !dataItem.dateApproved1">
              {{ dataItem.dateRejected1 | date: 'dd.MM.YYYY' }}
            </span>
            <span *ngIf="dataItem.dateApproved1"
                  [style.color]="'#004d25'">
              {{ dataItem.approvalUser1 }}
            </span>
            <span *ngIf="dataItem.dateRejected1 && !dataItem.dateApproved1"
                  [style.color]="!isProjectRejected() && currentUser.OID == dataItem.approval1 ? '#056ed1' : '#df3330'">
              {{ dataItem.approvalUser1 }}
            </span>
            <span *ngIf="!dataItem.dateApproved1 && !dataItem.dateRejected1"
                  [style.color]="isProjectSelected && currentUser.OID == dataItem.approval1 ? '#056ed1' : ''">
              {{ dataItem.approvalUser1 }}
            </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [headerClass]="'participants-grid fixed-properties-column-width'"
                           field="approvalUser2"
                           title=""
                           [width]="170">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="approved-date"
                  *ngIf="dataItem.dateApproved2">
              {{ dataItem.dateApproved2 | date: 'dd.MM.YYYY' }}
            </span>
            <span class="approved-date"
                  *ngIf="dataItem.dateRejected2 && !dataItem.dateApproved2">
              {{ dataItem.dateRejected2 | date: 'dd.MM.YYYY' }}
            </span>
            <span *ngIf="dataItem.dateApproved2"
                  [style.color]="'#004d25'">
              {{ dataItem.approvalUser2 }}
            </span>
            <span *ngIf="dataItem.dateRejected2 && !dataItem.dateApproved2"
                  [style.color]="isProjectSelected && currentUser.OID == dataItem.approval2 ? '#056ed1' : '#df3330'">
              {{ dataItem.approvalUser2 }}
            </span>
            <span *ngIf="!dataItem.dateApproved2 && !dataItem.dateRejected2"
                  [style.color]="isProjectSelected && currentUser.OID == dataItem.approval2 ? '#056ed1' : ''">
              {{ dataItem.approvalUser2 }}
            </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [headerClass]="'participants-grid fixed-properties-column-width'"
                           field="approvalUser3"
                           title=""
                           [width]="170">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="approved-date"
                  *ngIf="dataItem.dateApproved3">
              {{ dataItem.dateApproved3 | date: 'dd.MM.YYYY' }}
            </span>
            <span class="approved-date"
                  *ngIf="dataItem.dateRejected3 && !dataItem.dateApproved3">
              {{ dataItem.dateRejected3 | date: 'dd.MM.YYYY' }}
            </span>
            <span *ngIf="dataItem.dateApproved3"
                  [style.color]="(!!dataItem.dateApproved3 || !dataItem.dateRejected3) || (!!dataItem.dateApproved3 && !!dataItem.dateRejected3 && dataItem.dateApproved3 > dataItem.dateRejected3) ? '#004d25' : ''">
              {{ dataItem.approvalUser3 }}
            </span>
            <span *ngIf="dataItem.dateRejected3 && !dataItem.dateApproved3"
                  [style.color]="!dataItem.dateApproved3  && currentUser.OID == dataItem.approval3? '#056ed1' : '#df3330'">
                  {{ dataItem.approvalUser3 }}
            </span>
            <span *ngIf="!dataItem.dateApproved3 && !dataItem.dateRejected3"
                  [style.color]="isProjectSelected && currentUser.OID == dataItem.approval3 ? '#056ed1' : ''">
              {{ dataItem.approvalUser3 }}
            </span>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
    <div class="approval-body">
      <kendo-grid [data]="data"
                  #approvalTaskGrid
                  *ngIf="!groupBy"
                  class="kendo-white-grid approval-grid"
                  [selectable]="selectableSettings"
                  (cellClick)="onApprovalSelection($event, false)"
                  (drop)="onDrop($event)"
                  (dragover)="onDragOver($event, approvalTaskGrid)"
                  (dragstart)="onDragStart($event, approvalTaskGrid)">
        <kendo-grid-column title="" [width]="50">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div>
              <input type="checkbox"
                     [ngClass]="isPropertyApproved(dataItem) ? 'property-approved' : !isSelected(dataItem) && isPropertyRejected(dataItem) ? 'property-rejected' : ''"
                     [(ngModel)]="dataItem.isSelected"
                     (click)="onPropertySelect(dataItem)" />
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [headerClass]="'participants-grid'"
                           field="municipally"
                           title="{{'raci.portfolioProperties.titleMunicipally' | translate}}"
                           [width]="auto"></kendo-grid-column>
        <kendo-grid-column [headerClass]="'participants-grid'"
                           field="address"
                           title="{{'raci.portfolioProperties.titleAddress' | translate}}"
                           [width]="auto"></kendo-grid-column>
        <kendo-grid-column [headerClass]="'participants-grid fixed-properties-column-width'"
                           field="approvalUser1"
                           title=""
                           [width]="170">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="approved-date"
                  *ngIf="dataItem.dateApproved1">
              {{ dataItem.dateApproved1 | date: 'dd.MM.YYYY' }}
            </span>
            <span class="approved-date"
                  *ngIf="dataItem.dateRejected1 && !dataItem.dateApproved1">
              {{ dataItem.dateRejected1 | date: 'dd.MM.YYYY' }}
            </span>
            <span *ngIf="dataItem.dateApproved1"
                  [style.color]="(!!dataItem.dateApproved1 || !dataItem.dateRejected1) || (!!dataItem.dateApproved1 && !!dataItem.dateRejected1 && dataItem.dateApproved1 > dataItem.dateRejected1) ? '#004d25' : ''">
              {{ dataItem.approvalUser1 }}
            </span>
            <span *ngIf="!dataItem.dateApproved1 && !dataItem.dateRejected1"
                  [style.color]="isSelected(dataItem) && currentUser.OID == dataItem.approval1 ? '#056ed1' : ''">
              {{ dataItem.approvalUser1 }}
            </span>
            <span *ngIf="dataItem.dateRejected1 && !dataItem.dateApproved1"
                   [style.color]="!dataItem.dateApproved1  && isSelected(dataItem) && currentUser.OID == dataItem.approval1 ? '#056ed1' : '#df3330'">
              {{ dataItem.approvalUser1 }}
            </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [headerClass]="'participants-grid fixed-properties-column-width'"
                           field="approvalUser2" title=""
                           [width]="170">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="approved-date"
                  *ngIf="dataItem.dateApproved2">
              {{ dataItem.dateApproved2 | date: 'dd.MM.YYYY' }}
            </span>
            <span class="approved-date"
                  *ngIf="dataItem.dateRejected2 && !dataItem.dateApproved2">
              {{ dataItem.dateRejected2 | date: 'dd.MM.YYYY' }}
            </span>
            <span *ngIf="dataItem.dateApproved2"
                  [style.color]="(!!dataItem.dateApproved2 || !dataItem.dateRejected2) || (!!dataItem.dateApproved2 && !!dataItem.dateRejected2 && dataItem.dateApproved2 > dataItem.dateRejected2) ? '#004d25' : ''">
              {{ dataItem.approvalUser2 }}
            </span>
            <span *ngIf="!dataItem.dateApproved2 && !dataItem.dateRejected2"
                  [style.color]="isSelected(dataItem) && currentUser.OID == dataItem.approval2 ? '#056ed1' : ''">
              {{ dataItem.approvalUser2 }}
            </span>
            <span *ngIf="dataItem.dateRejected2 && !dataItem.dateApproved2"
                  [style.color]="!dataItem.dateApproved2 && isSelected(dataItem) && currentUser.OID == dataItem.approval2 ? '#056ed1' : '#df3330'">
              {{ dataItem.approvalUser2 }}
            </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [headerClass]="'participants-grid fixed-properties-column-width'"
                           field="approvalUser3"
                           title=""
                           [width]="170">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="approved-date"
                  *ngIf="dataItem.dateApproved3">
              {{ dataItem.dateApproved3 | date: 'dd.MM.YYYY' }}
            </span>
            <span class="approved-date"
                  *ngIf="dataItem.dateRejected3 && !dataItem.dateApproved3">
              {{ dataItem.dateRejected3 | date: 'dd.MM.YYYY' }}
            </span>
            <span *ngIf="dataItem.dateApproved3"
                  [style.color]="(!!dataItem.dateApproved3 || !dataItem.dateRejected3) || (!!dataItem.dateApproved3 && !!dataItem.dateRejected3 && dataItem.dateApproved3 > dataItem.dateRejected3) ? '#004d25' : ''">
              {{ dataItem.approvalUser3 }}
            </span>
            <span *ngIf="!dataItem.dateApproved3 && !dataItem.dateRejected3"
                  [style.color]="isSelected(dataItem) && currentUser.OID == dataItem.approval3 ? '#056ed1' : ''">
              {{ dataItem.approvalUser3 }}
            </span>
            <span *ngIf="dataItem.dateRejected3 && !dataItem.dateApproved3 "
                  [style.color]="!dataItem.dateApproved3  && isSelected(dataItem) && currentUser.OID == dataItem.approval3 ? '#056ed1' : '#df3330'">
              {{ dataItem.approvalUser3 }}
            </span>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
      <div *ngIf="groupBy">
        <div class="spacing-bottom-5" *ngFor="let item of groupData">
          <kendo-grid [data]="item.approvals"
                      #groupGrid
                      class="kendo-white-grid group-header"
                      (cellClick)="onGroupSelection($event, item)"
                      [hideHeader]="true">
            <kendo-grid-column title="" [width]="50">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div>
                  <input type="checkbox"
                         [ngClass]="isGroupPropertyApproved(item) ? 'property-approved' : !item.isSelected && isGroupPropertyRejected(item) ? 'property-rejected' : ''"
                         [(ngModel)]="item.isSelected"
                         (click)="selectAllPropertiesOfGroup(item)" />
                </div>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [headerClass]="'participants-grid group-name'"
                               field="project"
                               title="project"
                               class="fill-line"
                               [width]="auto">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div class="group-name-wrapper">
                  <h4 class="properties-name" *ngIf="groupBy">{{item.group}}</h4>
                  <div class="dashed-bottom"></div>
                </div>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [headerClass]="'participants-grid fill-line'"
                               field="line"
                               title="line"
                               [width]="auto">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div class="dashed-bottom"></div>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [headerClass]="'participants-grid fixed-properties-column-width'"
                               field="approvalUser1"
                               title=""
                               [width]="170">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span *ngIf="!dataItem.approval1"
                      [style.font-style]="'italic'">Select user</span>
                <span class="approved-date"
                      *ngIf="dataItem.dateApproved1">
                  {{ dataItem.dateApproved1 | date: 'dd.MM.YYYY' }}
                </span>
                <span class="approved-date"
                      *ngIf="dataItem.dateRejected1 && !dataItem.dateApproved1">
                  {{ dataItem.dateRejected1 | date: 'dd.MM.YYYY' }}
                </span>
                <span *ngIf="dataItem.dateApproved1"
                      [style.color]="(!!dataItem.dateApproved1 || !dataItem.dateRejected1) || (!!dataItem.dateApproved1 && !!dataItem.dateRejected1 && dataItem.dateApproved1 > dataItem.dateRejected1) ? '#004d25' : ''">
                  {{ dataItem.approvalUser1 }}
                </span>
                <span *ngIf="dataItem.dateRejected1 && !dataItem.dateApproved1"
                      [style.color]="!dataItem.dateApproved1 && item.isSelected && currentUser.OID == dataItem.approval1 ? '#056ed1' : '#df3330'">
                  {{ dataItem.approvalUser1 }}
                </span>
                <span *ngIf="!dataItem.dateApproved1 && !dataItem.dateRejected1"
                      [style.color]="item.isSelected && currentUser.OID == dataItem.approval1 ? '#056ed1' : ''">
                  {{ dataItem.approvalUser1 }}
                </span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [headerClass]="'participants-grid fixed-properties-column-width'"
                               field="approvalUser2"
                               title=""
                               [width]="170">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span *ngIf="!dataItem.approval2"
                      [style.font-style]="'italic'">Select user</span>
                <span class="approved-date"
                      *ngIf="dataItem.dateApproved2">
                  {{ dataItem.dateApproved2 | date: 'dd.MM.YYYY' }}
                </span>
                <span class="approved-date"
                      *ngIf="dataItem.dateRejected2 && !dataItem.dateApproved2">
                  {{ dataItem.dateRejected2 | date: 'dd.MM.YYYY' }}
                </span>
                <span *ngIf="dataItem.dateApproved2"
                      [style.color]="(!!dataItem.dateApproved2 || !dataItem.dateRejected2) || (!!dataItem.dateApproved2 && !!dataItem.dateRejected2 && dataItem.dateApproved2 > dataItem.dateRejected2) ? '#004d25' : ''">
                  {{ dataItem.approvalUser2 }}
                </span>
                <span *ngIf="dataItem.dateRejected2 && !dataItem.dateApproved2"
                      [style.color]="!dataItem.dateApproved2 && item.isSelected && currentUser.OID == dataItem.approval2 ? '#056ed1' : '#df3330'">
                  {{ dataItem.approvalUser2 }}
                </span>
                <span *ngIf="!dataItem.dateApproved2 && !dataItem.dateRejected2"
                      [style.color]="item.isSelected && currentUser.OID == dataItem.approval2 ? '#056ed1' : ''">
                  {{ dataItem.approvalUser2 }}
                </span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [headerClass]="'participants-grid fixed-properties-column-width'"
                               field="approvalUser3"
                               title=""
                               [width]="170">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span *ngIf="!dataItem.approval3"
                      [style.font-style]="'italic'">Select user</span>
                <span class="approved-date"
                      *ngIf="dataItem.dateApproved3">
                  {{ dataItem.dateApproved3 | date: 'dd.MM.YYYY' }}
                </span>
                <span class="approved-date"
                      *ngIf="dataItem.dateRejected3 && !dataItem.dateApproved3">
                  {{ dataItem.dateRejected3 | date: 'dd.MM.YYYY' }}
                </span>
                <span *ngIf="dataItem.dateApproved3"
                      [style.color]="(!!dataItem.dateApproved3 || !dataItem.dateRejected3) || (!!dataItem.dateApproved3 && !!dataItem.dateRejected3 && dataItem.dateApproved3 > dataItem.dateRejected3) ? '#004d25' : ''">
                  {{ dataItem.approvalUser3 }}
                </span>
                <span *ngIf="dataItem.dateRejected3 && !dataItem.dateApproved3"
                      [style.color]="!dataItem.dateApproved3 && item.isSelected && currentUser.OID == dataItem.approval3 ? '#056ed1' : '#df3330'">
                  {{ dataItem.approvalUser3 }}
                </span>
                <span *ngIf="!dataItem.dateApproved3 && !dataItem.dateRejected3"
                      [style.color]="item.isSelected && currentUser.OID == dataItem.approval3 ? '#056ed1' : ''">
                  {{ dataItem.approvalUser3 }}
                </span>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
          <div class="group-by-body">
            <kendo-grid [data]="item.tasks"
                        #approvalTaskGrid
                        class="kendo-white-grid group-approval-grid"
                        [selectable]="selectableSettings"
                        kendoGridSelectBy="oid"
                        [(selectedKeys)]="item.selectedRows"
                        (selectedKeysChange)="onSelectionChange(item.group)"
                        (cellClick)="onApprovalSelection($event, false)"
                        (drop)="onDrop($event, false, item.group)"
                        (dragover)="onDragOver($event, approvalTaskGrid)"
                        (dragstart)="onDragStart($event, approvalTaskGrid)">
              <kendo-grid-column title="" [width]="50">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div>
                    <input type="checkbox"
                           [ngClass]="isPropertyApproved(dataItem) ? 'property-approved' : !isSelected(dataItem) && isPropertyRejected(dataItem) ? 'property-rejected' : ''"
                           [(ngModel)]="dataItem.isSelected"
                           (click)="onPropertySelect(dataItem, true)" />
                  </div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="municipally"
                                 title="{{'raci.portfolioProperties.titleMunicipally' | translate}}"
                                 [width]="auto">

              </kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="address"
                                 title="{{'raci.portfolioProperties.titleAddress' | translate}}"
                                 [width]="auto"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid fixed-properties-column-width'"
                                 field="approvalUser1"
                                 title=""
                                 [width]="170">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="approved-date"
                        *ngIf="dataItem.dateApproved1">
                    {{ dataItem.dateApproved1 | date: 'dd.MM.YYYY' }}
                  </span>
                  <span class="approved-date"
                        *ngIf="dataItem.dateRejected1 && !dataItem.dateApproved1">
                    {{ dataItem.dateRejected1 | date: 'dd.MM.YYYY' }}
                  </span>
                  <span *ngIf="dataItem.dateApproved1"
                        [style.color]="(!!dataItem.dateApproved1 || !dataItem.dateRejected1) || (!!dataItem.dateApproved1 && !!dataItem.dateRejected1 && dataItem.dateApproved1 > dataItem.dateRejected1) ? '#004d25' : ''">
                    {{ dataItem.approvalUser1 }}
                  </span>
                  <span *ngIf="!dataItem.dateApproved1 && !dataItem.dateRejected1"
                        [style.color]="isSelected(dataItem) && currentUser.OID == dataItem.approval1 ? '#056ed1' : ''">
                    {{ dataItem.approvalUser1 }}
                  </span>
                  <span *ngIf="dataItem.dateRejected1 && !dataItem.dateApproved1"
                        [style.color]="!dataItem.dateApproved1  && isSelected(dataItem) && currentUser.OID == dataItem.approval1 ? '#056ed1' : '#df3330'">
                    {{ dataItem.approvalUser1 }}
                  </span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid fixed-properties-column-width'"
                                 field="approvalUser2"
                                 title=""
                                 [width]="170">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="approved-date"
                        *ngIf="dataItem.dateApproved2">
                    {{ dataItem.dateApproved2 | date: 'dd.MM.YYYY' }}
                  </span>
                  <span class="approved-date"
                        *ngIf="dataItem.dateRejected2 && !dataItem.dateApproved2">
                    {{ dataItem.dateRejected2 | date: 'dd.MM.YYYY' }}
                  </span>
                  <span *ngIf="dataItem.dateApproved2"
                        [style.color]="(!!dataItem.dateApproved2 || !dataItem.dateRejected2) || (!!dataItem.dateApproved2 && !!dataItem.dateRejected2 && dataItem.dateApproved2 > dataItem.dateRejected2) ? '#004d25' : ''">
                    {{ dataItem.approvalUser2 }}
                  </span>
                  <span *ngIf="!dataItem.dateApproved2 && !dataItem.dateRejected2"
                        [style.color]="isSelected(dataItem) && currentUser.OID == dataItem.approval2 ? '#056ed1' : ''">
                    {{ dataItem.approvalUser2 }}
                  </span>
                  <span *ngIf="dataItem.dateRejected2 && !dataItem.dateApproved2 "
                        [style.color]="!dataItem.dateApproved2  && isSelected(dataItem) && currentUser.OID == dataItem.approval2  ? '#056ed1' : '#df3330'">
                    {{ dataItem.approvalUser2 }}
                  </span>
                </ng-template>

              </kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid fixed-properties-column-width'"
                                 field="approvalUser3"
                                 title=""
                                 [width]="170">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span class="approved-date"
                        *ngIf="dataItem.dateApproved3">
                    {{ dataItem.dateApproved3 | date: 'dd.MM.YYYY' }}
                  </span>
                  <span class="approved-date"
                        *ngIf="dataItem.dateRejected3 && !dataItem.dateApproved3">
                    {{ dataItem.dateRejected3 | date: 'dd.MM.YYYY' }}
                  </span>
                  <span *ngIf="dataItem.dateApproved3"
                        [style.color]="(!!dataItem.dateApproved3 || !dataItem.dateRejected3) || (!!dataItem.dateApproved3 && !!dataItem.dateRejected3 && dataItem.dateApproved3 > dataItem.dateRejected3) ? '#004d25' : ''">
                    {{ dataItem.approvalUser3 }}
                  </span>
                  <span *ngIf="!dataItem.dateApproved3 && !dataItem.dateRejected3"
                        [style.color]="isSelected(dataItem) && currentUser.OID == dataItem.approval3 ? '#056ed1' : ''">
                    {{ dataItem.approvalUser3 }}
                  </span>

                  <span *ngIf="dataItem.dateRejected3 && !dataItem.dateApproved3 "
                        [style.color]="!dataItem.dateApproved3  && isSelected(dataItem) && currentUser.OID == dataItem.approval3  ? '#056ed1' : '#df3330'">
                    {{ dataItem.approvalUser3 }}
                  </span>
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<raci-approval-dialog class="raci-approval-matrix-dialog" *ngIf="isApprovalDialogDisplayed" [isGeneralTask]="false" (onApprove)="onApprove($event)"></raci-approval-dialog>
